module.exports = __webpack_public_path__ + "img/18.94cfbd95.png";